import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

// Styles
import "./assets/styles/style.scss";

function Admin({ baseDomain }) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const pageSize = 20;

  const token = localStorage.getItem("token");

  const getData = useCallback(
    async (pageToLoad) => {
    setIsLoading(true);

      try {
        const response = await axios.get(`${baseDomain}/getResults`, {
          params: {
            page: pageToLoad,
            limit: pageSize,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data.items || []);
        setTotal(response.data.total || 0);
      } catch (error) {
        window.location.href = "/login";
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    },
    [baseDomain, pageSize, token]
  );

  useEffect(() => {
    getData(page);
  }, [getData, page]);

  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages]);

  return (
    <div className="App p-5 admin">
      <div className="text-center">

        {isLoading ? (
          <h1>LOADING ...</h1>
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center my-3">
              <button
                className="btn btn-outline-secondary"
                disabled={page <= 1 || isLoading}
                onClick={() => setPage((current) => Math.max(current - 1, 1))}>
                Prev
              </button>
              <div>
                Page {page} of {totalPages} · {total} total
              </div>
              <button
                className="btn btn-outline-secondary"
                disabled={page >= totalPages || isLoading}
                onClick={() =>
                  setPage((current) => Math.min(current + 1, totalPages))
                }>
                Next
              </button>
            </div>
            <table className="table text-start">
              <thead>
                <tr>
                  <th style={{ width: "5%" }} scope="col">
                    #
                  </th>
                  <th style={{ width: "40%" }} scope="col">
                    Prompt
                  </th>
                  <th style={{ width: "50%" }} scope="col">
                    Result
                  </th>
                  <th style={{ width: "5%" }} scope="col">
                    Rating
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <th scope="row">
                      {total
                        ? total - (page - 1) * pageSize - index
                        : data.length - index}
                    </th>
                    <td>
                      {item.prompt}
                      <br />
                      <br />
                      Published:
                      <br />
                      <strong>{convertUtcToSlovenia(item.created)}</strong>
                      <br />
                      {item.proccessingTime && (
                        <>
                          <br />
                          Proccessing time:
                          <br />
                          <strong>
                            {Math.trunc(item.proccessingTime / 1000)}s
                          </strong>
                          <br />
                        </>
                      )}
                    </td>
                    <td>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            typeof item.result === "object"
                              ? item.result.content
                              : item.result,
                        }}></div>
                    </td>
                    <td>
                      {item.rating !== null && item.rating.length !== 0 ? (
                        <>
                          <strong>
                            {Math.round(
                              item.rating.reduce((a, b) => a + b, 0) /
                                item.rating.length
                            )}
                          </strong>
                          <small> ({item.rating.length}x)</small>
                        </>
                      ) : (
                        <strong>N/A </strong>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="d-flex justify-content-between align-items-center my-3">
              <button
                className="btn btn-outline-secondary"
                disabled={page <= 1 || isLoading}
                onClick={() => setPage((current) => Math.max(current - 1, 1))}>
                Prev
              </button>
              <div>
                Page {page} of {totalPages} · {total} total
              </div>
              <button
                className="btn btn-outline-secondary"
                disabled={page >= totalPages || isLoading}
                onClick={() =>
                  setPage((current) => Math.min(current + 1, totalPages))
                }>
                Next
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function convertUtcToSlovenia(utcTimestamp) {
  const createdUtc = new Date(utcTimestamp);
  const createdSlovenia = new Date(createdUtc.getTime() + 0 * 60 * 60 * 1000);
  const createdDateString = createdSlovenia.toLocaleDateString("sl-SI", {
    timeZone: "Europe/Ljubljana",
  });
  const createdTimeString = createdSlovenia.toLocaleTimeString("sl-SI", {
    timeZone: "Europe/Ljubljana",
  });
  return `${createdDateString} ${createdTimeString}`;
}

export default Admin;
